import { gql, useMutation } from '@apollo/client';
import { EMPLOYEE_FIELDS, Employee } from '@dieterApi/user/useUserQuery';

const ADD_EMPLOYEE = gql`
  ${EMPLOYEE_FIELDS}
  mutation addEmployee($name: String!, $email: String) {
    addEmployee(name: $name, email: $email) {
      ...UserEmployeeFields
    }
  }
`;

export interface AddEmployeeResult {
  addEmployee: Employee;
}

export interface AddEmployeeInput {
  name: string;
  email?: string;
}

export interface AddEmployeeContext {
  companyId: string;
}

export function useEmployeeAddMutation() {
  return useMutation<AddEmployeeResult, AddEmployeeInput, AddEmployeeContext>(ADD_EMPLOYEE, {
    update: (cache, { data }, options) => {
      if (!data?.addEmployee) {
        return;
      }
      const companyId = options.context?.companyId;
      if (!companyId) {
        return;
      }

      const cacheId = `Company:${companyId}`;

      cache.modify({
        id: cacheId,
        fields: {
          employees(existingEmployees = [], { readField }) {
            const newEmployeeRef = cache.writeFragment({
              data: data.addEmployee,
              fragment: EMPLOYEE_FIELDS,
            });

            // Check if already exists to avoid duplicates
            if (existingEmployees.some((ref: any) => readField('id', ref) === data.addEmployee.id)) {
              return existingEmployees;
            }

            return [...existingEmployees, newEmployeeRef];
          },
        },
      });
    },
  });
}
